export default {
    before: 'avant',
    after: 'après',
};
